import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import { NotificationTypeEnum } from '../../enums';

export interface NotificationSnackBarData {
  message: string;
  type: NotificationTypeEnum;
}

const ICON_PATH_MAP: Partial<Record<NotificationTypeEnum, string>> = {
  [NotificationTypeEnum.SUCCESS]: 'assets/images/icons/success-notification-icon.svg',
  [NotificationTypeEnum.ERROR]: 'assets/images/icons/error-notification-icon.svg',
  [NotificationTypeEnum.INFO]: 'assets/images/icons/info-notification-icon.svg',
};

@Component({
  selector: 'app-notification-snackbar',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="notification" [ngClass]="typeClass">
      @if (iconPath) {
        <img class="notification__icon" [src]="iconPath" alt="" />
      }
      <span class="notification__message">{{ data.message }}</span>
    </div>
  `,
  styles: [
    `
      .notification {
        display: flex;
        align-items: flex-start;
      }

      .notification__icon {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        margin-top: 5px;
        margin-right: 10px;
      }

      .notification__message {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100%;
      }
    `,
  ],
})
export class NotificationSnackBarComponent {
  data = inject<NotificationSnackBarData>(MAT_SNACK_BAR_DATA);
  iconPath = ICON_PATH_MAP[this.data.type] ?? null;
  typeClass = `notification--${this.data.type}`;
}
